import React from "react";
import ReworkProductDetail from "../../../components/user/reworkProduct/reworkProductDetail";
import Layout from "../../../components/layouts/verticalLayout";
import { useParams } from "react-router-dom";

const ReworkProductDetailPage = (props) => {
  let { uuid } = useParams();
  return (
    <Layout
      body={
        <>
          <ReworkProductDetail uuid={uuid} />
        </>
      }
    />
  );
};

ReworkProductDetailPage.propTypes = {};

export default ReworkProductDetailPage;
